import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../hooks/useAuth';
import { fetchTailoredCV } from '../../lib/tailored-cv-api';
import { canReadCvImportEvidence, fetchCvImportEvidence } from '../../lib/cv-import-evidence';

export interface CvImportEvidenceNoticeProps {
  cvId?: string | null;
  /** False for a delegated editor, even when it has edit permission. */
  enabled?: boolean;
}

export function useCvImportEvidence({ cvId, enabled = true }: CvImportEvidenceNoticeProps) {
  const { user } = useAuth();
  const isTailored = Boolean(cvId && cvId !== 'master');
  const owner = useQuery({
    queryKey: ['cv', cvId, 'import-evidence-owner', user?.id],
    queryFn: () => fetchTailoredCV(cvId!),
    enabled: enabled && Boolean(user?.id) && isTailored,
  });
  const allowed = canReadCvImportEvidence({ enabled, cvId, userId: user?.id, ownerId: owner.data?.userId });
  const query = useQuery({
    queryKey: ['cv', cvId || 'master', 'import-evidence', user?.id],
    queryFn: () => fetchCvImportEvidence(cvId),
    enabled: allowed,
    staleTime: 0,
  });
  return { ...query, data: allowed ? query.data : null, allowed };
}
